import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "@/app/utils/handleApiError";
import { RejectValueType } from "../redux/redux.types";
import { fetchHomeSection } from "./home.service";
import { HomeAnySection } from "./home.state";
import type { RootState } from "@/app/lib/store";

/**
 * TEK bir section'ı kimlikli olarak yeniden çeker (KATMAN 2).
 *
 * Eskiden burada `getHomePageData` vardı: key listesini + 18 section'ın hepsini
 * her ana sayfa açılışında, giriş yapılmamış ziyaretçilerde bile yeniden
 * çekiyordu. Section'ların 13'ü `content_source: "manual"` (banner/kategori) —
 * yani herkes için birebir aynı; ISR HTML'iyle aynı veriyi geri yazmaktan
 * başka bir şey yapmıyordu.
 *
 * Artık istek section başına ve yalnızca gerekliyse atılıyor; kime/ne zaman
 * atılacağının kuralı usePersonalizedSection'da.
 */
export const getHomeSection = createAsyncThunk<
  { slug: string; section: HomeAnySection },
  string,
  RejectValueType & { state: RootState }
>(
  "home/getHomeSection",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await fetchHomeSection(slug);
      if (!response?.status || !response.data) {
        return rejectWithValue("Section verisi alınamadı.");
      }
      return { slug, section: response.data as HomeAnySection };
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    // Aynı slug uçuştayken ikinci isteği hiç başlatma — StrictMode'un çift
    // mount'u ve hızlı geri/ileri navigasyon aksi hâlde isteği ikiye katlar.
    condition: (slug, { getState }) => getState().home.status[slug] !== "loading",
  },
);
